import { ComponentType } from "react";
import { PersonMiddleNameFragment } from "gql/graphql";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Hidable, Value } from "@/shared/value";

/**
 * Отчество человека отдельным полем: в анкете части имени показываются по одной,
 * а само отчество — локализованное значение и может быть закрыто защитой.
 */
export function PersonMiddleName({
  data,
  whenEmpty,
}: {
  data?: Hidable<PersonMiddleNameFragment>;
  whenEmpty?: ComponentType;
}) {
  return (
    <Value data={data} whenEmpty={whenEmpty}>
      {(person) => (
        <LocalizedName data={person.middleName} whenEmpty={whenEmpty} />
      )}
    </Value>
  );
}
